<div class="modal inmodal fade in parcel-modal create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Legal Agreement</h4>
                </div>
                <div class="modal-body">
                    <div [ngClass]="{'agreement-header' : showLegalAgreementEditPanel}"
                         style="min-height: 48px;"
                         (dblclick)="showLegalAgreementEditPanelSetter()">
                        <h3>
                            Agreement
                            <i *ngIf="!showLegalAgreementEditPanel"
                               class="fa fa-pencil"
                               (click)="showLegalAgreementEditPanelSetter()"
                               data-placement="top" data-toggle="tooltip" title="Edit"></i>
                        </h3>
                        <div *ngIf="!showLegalAgreementEditPanel" [innerHtml]="legalAgreement | safeHtml"></div>
                        <div *ngIf="showLegalAgreementEditPanel" class="dv-value-edit">
                            <button (click)="onSubmit({legalAgreement: legalAgreement})" [disabled]="disabledSubmit">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" (click)="closeLegalAgreementEditPanel()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="showLegalAgreementEditPanel">
                        <div class="form-group" id="summernote">{{legalAgreement}}</div>
                    </div>
                    <div *ngIf="!showConfirmationMessageEditPanel">
                        <h3>Confirmation Message</h3>
                        <div *ngIf="settingsAmenitiesService.spinnerShow">
                            {{settingsAmenitiesService.selectedItemData.confirmationMessage ? settingsAmenitiesService.selectedItemData.confirmationMessage : '-'}}
                        </div>
                        <input-field *ngIf="!settingsAmenitiesService.spinnerShow"
                                     name="confirmationMessage"
                                     [ngModel]="settingsAmenitiesService.selectedItemData.confirmationMessage"
                                     [noEdit]="confirmationMessageInputDisabled"
                                     (update)="onSubmit({confirmationMessage: form.value.confirmationMessage})">
                        </input-field>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/legal-agreement-modal/legal-agreement-modal.component.html